export default __webpack_public_path__ + "static/media/Taiwan.df8bb9b0.svg";